module.exports = __webpack_public_path__ + "images/banners/jmty_lead/banner_sp_af796ed63462e83981b648d93a735470.jpg";